import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import { useLanguage } from "../context/LanguageContext";
import { usePageMeta } from "../utils/usePageMeta";

const NotFoundPage = () => {
    const navigate = useNavigate();
    const { t, language, lp } = useLanguage();

    usePageMeta({
        title: `${t("notFound.title")} | kh-tools.com`,
        description: t("notFound.subtitle"),
        lang: language,
        noindex: true,
    });

    return (
        <div className="min-h-screen bg-white">
            <Header title="" showBack onBack={() => navigate(lp("/"))} />
            <div className="flex flex-col items-center justify-center min-h-[70vh] px-6 text-center">
                <div className="text-[80px] font-black text-dewalt leading-none mb-4">
                    404
                </div>
                <h1 className="text-xl font-bold text-black mb-2">
                    {t("notFound.title")}
                </h1>
                <p className="text-sm text-gray-500 mb-8">
                    {t("notFound.subtitle")}
                </p>
                <button
                    onClick={() => navigate(lp("/"))}
                    className="px-8 py-3 bg-dewalt border-none rounded-xl text-base font-bold cursor-pointer transition-all duration-200 hover:bg-dewalt-hover active:scale-[0.98]"
                >
                    {t("notFound.goHome")}
                </button>
            </div>
        </div>
    );
};

export default NotFoundPage;
